import PromoDialog from "./PromoDialog.vue";

export {PromoDialog}
export default PromoDialog
